import React, { useState } from 'react';
import NavBar from './layouts/NavBar';
import { Container, Form, Button, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import Footer from './layouts/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faLock, faSave } from '@fortawesome/free-solid-svg-icons';

const FormularioEditarPerfil = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simple validation
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      setSuccess('');
      setIsSubmitting(false);
      return;
    }
    
    if (password.trim() === '' || confirmPassword.trim() === '') {
      setError('La contraseña no puede estar vacía.');
      setSuccess('');
      setIsSubmitting(false);
      return;
    }

    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      setSuccess('');
      setIsSubmitting(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      setError('');
      setSuccess('La contraseña se ha actualizado correctamente.');
      setIsSubmitting(false);
      // Reset form
      setPassword('');
      setConfirmPassword('');
    }, 1500);
  };

  return (
    <Container fluid className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <NavBar />
      
      <Row className="justify-content-center mt-4">
        <Col xl={6} lg={8} md={10}>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-primary text-white">
              <h3 className="mb-0">
                <FontAwesomeIcon icon={faUser} className="me-2" />
                Editar Perfil
              </h3>
            </Card.Header>
            
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                {/* Username Field */}
                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    Nombre de Usuario
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingresa tu nombre de usuario"
                    readOnly
                    className="py-2"
                  />
                </Form.Group>

                {/* Email Field */}
                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ingresa tu email"
                    readOnly
                    className="py-2"
                  />
                </Form.Group>

                {/* Password Field */}
                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">
                    <FontAwesomeIcon icon={faLock} className="me-2" />
                    Nueva Contraseña
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Mínimo 8 caracteres"
                    className="py-2"
                  />
                  <Form.Text muted>
                    La contraseña debe contener al menos 8 caracteres.
                  </Form.Text>
                </Form.Group>

                {/* Confirm Password Field */}
                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">
                    <FontAwesomeIcon icon={faLock} className="me-2" />
                    Confirmar Contraseña
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    placeholder="Confirma tu nueva contraseña"
                    className="py-2"
                  />
                </Form.Group>

                {/* Status Messages */}
                {error && (
                  <Alert variant="danger" className="mt-3">
                    {error}
                  </Alert>
                )}
                
                {success && (
                  <Alert variant="success" className="mt-3">
                    {success}
                  </Alert>
                )}

                {/* Submit Button */}
                <div className="d-grid gap-2 mt-4">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    size="lg"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Procesando...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faSave} className="me-2" />
                        Guardar Cambios
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <Footer />
    </Container>
  );
};

export default FormularioEditarPerfil;